// extracted by mini-css-extract-plugin
export default {"content":"content__FNqvr","header":"header__WHxNl"};